import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { useAppContext } from '../../Context';
import { useTranslation } from '../../TranslationContext';
import { motion } from 'framer-motion';

function SearchBox() {
	const { psServer, codeFormat, setIsLoading, setCodeFailed, qrCodeValue, setSubmittedCode, setShowTermsPopup, setIsVisible, setGallery, setAllowPurchase, setGDPRDaysLeft, setFullCodeData } = useAppContext();
	const { t } = useTranslation();
	const [inputValue, setInputValue] = useState('');
	const [inputIsValid, setInputIsValid] = useState(true);
	const navigate = useNavigate();
	
	const ref = useRef();
	const submitCode = useRef();
	
	const handleChange = (event) => {
		setInputValue(event.target.value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		setIsLoading(true);
		setGallery([]);
		navigate('/');
		setTimeout(function() {
			// codeFailed
			// 1 invalid format
			// 2 not found
			if (checkFormat(inputValue)) {
				checkCode(inputValue);
			} else {
				setCodeFailed(1);
				setIsLoading(false);
			}
		}, 1000);
	};
	
	const checkFormat = (code) => {
		const eachFormat = codeFormat.split(';');
		return eachFormat.some((format) => {
			const regexPattern = format.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/X/g, '[a-zA-Z0-9]');
			const regex = new RegExp(`^${regexPattern}$`);
			return regex.test(code);
		});
	};

	const checkCode = async (code) => {
		try {
			
			
			var response = await fetch(psServer + "/ui/customer/" + code, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			});

			const data = await response.json();

			if (data && data.redir) {
				window.location.href = data.redir;
				return;
			}

			if (!("customerCode" in data) || data.customerCode === null) {
				throw "No code";
			}
			response = await fetch(psServer + "/ui/photos/get/" + code, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			});
			const PhotoData = await response.json();
			if (!("photos" in PhotoData) || PhotoData.photos.length === 0) {
				throw "No photos";
			}	
			
			data.termsAccepted === 0 ? setShowTermsPopup(true) : setShowTermsPopup(false);
			PhotoData.locked === 0 ? setAllowPurchase(false) : setAllowPurchase(true);
			setGDPRDaysLeft(data.daysLeft);
			setInputIsValid(data !== 0);
			setSubmittedCode(code);
			setIsVisible(false);
			setFullCodeData(data);
			setGallery(PhotoData.photos);
			navigate('/gallery');
		} catch (error) {
			setCodeFailed(2);
			console.log(error);
			setIsLoading(false);
			ref.current.style.backgroundColor = "#ff6565";
		}
	};
	
	useEffect(() => {
		if (qrCodeValue !== null) {
			setInputValue(qrCodeValue);
			setTimeout(function() {
				if (submitCode.current) {
					submitCode.current.click();
				}
			}, 500);
		}
	}, [qrCodeValue]);
	
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			className="searchCont"
		>
		<motion.form
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 1, ease: "easeInOut" }}
			onSubmit={handleSubmit}
			className="formBox"
		>
			<input className="codeInput" type="text" value={inputValue} onChange={handleChange} placeholder={t('inputCode')} style={{ backgroundColor: inputIsValid ? '#ffffff' : '#ff635e' }} ref={ref} />
			<button type="submit" className="go" ref={submitCode}>{t('buttonGo')}</button>
		</motion.form>
		</motion.div>
	);
}

export default SearchBox;